import React from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'
import { WaveSliders } from '../interactions/WaveSliders.jsx'
import { CardHistoryBack } from '../interactions/CardHistoryBack.jsx'
import { useCardHistory } from '../interactions/useCardHistory.js'

const WAVE_FIELDS = [
  { key: 'work',    label: 'Work',    color: 'var(--moss-500)',  bg: 'var(--moss-100)' },
  { key: 'energy',  label: 'Energy',  color: 'var(--olive-500)', bg: 'var(--olive-200)' },
  { key: 'outside', label: 'Outside', color: 'var(--clay-600)',  bg: 'var(--clay-100)' },
]

const CARD_DEF = { id: 'prep-wave', icon: '〜', label: 'Wave check-in' }

/**
 * WaveCard — three-axis vibe slider (work / energy / outside).
 * catalog #1, prep-wave. Greenfield interaction (WaveSliders).
 */
export function WaveCard({ card, value, onChange, disabled, ownerUserId }) {
  const { data: historyData, loading: historyLoading, error: historyError, fetch: fetchHistory } = useCardHistory(card?.prepCardId ?? 'prep-wave', ownerUserId)

  const back = (
    <CardHistoryBack
      cardDef={CARD_DEF}
      entries={historyData?.entries ?? []}
      loading={historyLoading}
      error={historyError}
      onFlip={() => {}}
    />
  )

  return (
    <CardFrame
      kind="prep"
      icon="〜"
      iconClass="moss"
      title="Wave check-in"
      prompt="How are the three bands right now?"
      state={disabled ? 'locked' : value ? 'filled' : 'empty'}
      back={back}
      data-testid="prep-card-prep-wave"
      className="prepcard"
    >
      <WaveSliders
        fields={WAVE_FIELDS}
        values={value ?? {}}
        onChange={onChange}
        disabled={disabled}
      />
    </CardFrame>
  )
}
